export default __webpack_public_path__ + "static/media/promtion_pro_one.d36cf94a.svg";